import classNames from "classnames";
import CardTitle from "../../../components/CardTitle";
import TMapComp from "../../../components/TMap";
import styles from "./WisdomPartyBuilding.module.scss";
import ManPng from "../../../images/man.png";
import WoManPng from "../../../images/woman.png";
import { Pie } from "@ant-design/plots";
import YearPicker from "../../../components/YearPicker";
import p1Png from "../../../images/test2.jpg";
import p2Png from "../../../images/test2.jpg";
import p36 from "../../../images/36.png";
import p64 from "../../../images/64.png";
import p642 from "../../../images/64-2.png";
import p643 from "../../../images/64-3.png";
// ../../../images/people-bg.png
import peopleBg from "../../../images/people-bg.png";
import { MainLayout } from "../../../components/Layout";
import styled from "@emotion/styled";
import { LiveTime } from "../../../components/LiveTime/index";
import { useCallback, useEffect, useRef, useState } from "react";
import { Progress } from "antd";
import request from "../../../utils/request";
import { Swiper, SwiperSlide } from "swiper/react";
import EchartIconPie from "./Charts/IconPie";
import EchartAgePie from "./Charts/AgePie";
import mapimg from "../../../images/map.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "./styles.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import Echart3DPie from "./Charts/3DPie";
import Echart3DOnlyBar from "./Charts/3DOnlyBar";
import { appName, isYushan } from "../../../config";
const WisdonPartyBuildIngLayout = styled.div`
  .ant-progress-text {
    color: #8cf9ff;
  }
  .quarters {
    margin-top: 35px;
    li {
      margin-bottom: 29px;
      color: #1afcff;
      font-size: 14px;
      align-items: center;
      img {
        margin-left: 33px;
        margin-right: 11px;
      }
    }
  }
  .middle-content {
    display: flex;
    flex-direction: column;
    height: 100%;

    .iframe-box {
      height: calc(100% - 280px);
      overflow: hidden;
      margin-bottom: 30px;
    }
    iframe {
      height: calc(100% + 15px);
      width: calc(100% + 18px);
      border: none;

      &::-webkit-scrollbar {
        width: 8px;
        height: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #61cdd7;
        width: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #4d898e;
      }
    }
  }
  .info-list {
    &-item {
      width: 100%;
      /* min-height: 31px; */
      padding: 10px;
      list-style: none;
      /* background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAboAAAAfCAYAAACRUQhsAAAAAXNSR0IArs4c6QAAAZNJREFUeF7t18FpQlEUBND7hQ9CjEjqsIM048o6fhu2lQLsIcSs3AiWMXNeB3PmwvCWud7WOTzO4xEgQIAAgTSB9Xlf5rLt5+vzOy2bPAQIECBAYJ7rj6FzBwQIECCQK2DocruVjAABAgRm/OhcAQECBAhkC/jRZfcrHQECBOoFDF39CQAgQIBAtoChy+5XOgIECNQLGLr6EwBAgACBbAFDl92vdAQIEKgXMHT1JwCAAAEC2QKGLrtf6QgQIFAvYOjqTwAAAQIEsgUMXXa/0hEgQKBewNDVnwAAAgQIZAsYuux+pSNAgEC9gKGrPwEABAgQyBYwdNn9SkeAAIF6AUNXfwIACBAgkC1g6LL7lY4AAQL1Aoau/gQAECBAIFvA0GX3Kx0BAgTqBQxd/QkAIECAQLaAocvuVzoCBAjUCxi6+hMAQIAAgWwBQ5fdr3QECBCoFzB09ScAgAABAtkChi67X+kIECBQL2Do6k8AAAECBLIFDF12v9IRIECgXuA9dNu2m9/jqR4DAAECBAjkCfx//L0ABGVhdsdNLWUAAAAASUVORK5CYII=); */
      background: rgba(2, 63, 84, 0.6);
      padding-left: 20px;
      color: #1cfbff;
      font-size: 12px;
      text-align: left;
      display: flex;
      /* justify-content: center; */
      align-items: center;
      overflow: hidden;
      word-wrap: normal;
      text-overflow: ellipsis;
    }
    .swiper-slide {
      text-align: left;
      background: rgba(2, 63, 84, 0.6);
      margin-bottom: 1px !important;
    }
  }
`;

const WisdomPartyBuilding: React.FC = () => {
  const sliders = [
    {
      img: p2Png,
      desc: "党群活动名称",
    },
    {
      img: p2Png,
      desc: "党群活动名称",
    },
    {
      img: p2Png,
      desc: "党群活动名称",
    },
  ];

  const infos = [
    "建设村民“大管家”服务平台",
    '加快城乡基础设施“均等化"',
    "建设区镇村三级行政审批服务和监督网络平台",
    "建立“一村一律师”制度",
    "治安防控“双网联动",
    "建立村级“小微权力”清单",
  ];

  const quarters = [
    {
      img: p36,
      label: "第一季度",
      value: "36%",
    },
    {
      img: p64,
      label: "第二季度",
      value: "36%",
    },
    {
      img: p642,
      label: "第三季度",
      value: "64%",
    },
    {
      img: p643,
      label: "第四季度",
      value: "64%",
    },
  ];
  const items = [
    "党组织数",
    "正式党员",
    "预备党员",
    "入党积极分子",
    "流动党员",
    "口袋党员",
    // '男性党员',
    // '女性党员',
  ];
  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear().toString()
  );
  const [data, setData] = useState<any>();
  const [currentActive, setCurrentActive] = useState<any>();
  const getData = async () => {
    try {
      // https://apiv2.wxstores.cn/screen/Other/getSamrtParty?years=2022
      const res = await request.get(
        "/screen/Other/getSamrtParty?years=" + currentYear
      );
      setData(res.data.data);
      setCurrentActive(res.data.data.active[0]);
    } catch (e) {}
  };
  useEffect(() => {
    // getProjectInfo();
    getData();
  }, [currentYear]);
  const config: React.ComponentProps<typeof Pie> = {
    height: 240,
    appendPadding: 10,
    data: data?.olds?.map((item: any) => {
      return {
        type: item.name,
        value: item.value,
      };
    }),
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    label: {
      type: "inner",
      offset: "-30%",
      content: "",
      style: {
        fontSize: 14,
        textAlign: "center",
        color: "#fff",
      },
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
    legend: {
      // position: 'right-top',
      offsetX: 8,
      // title: {
      //   text: '产品类别 (平均销售量）',
      //   spacing: 8,
      // },
      itemName: {
        style: (item, index) => {
          return {
            fill: "#fff",
          };
        },
      },
      // itemValue: {

      //   style: (item, index) => {
      //     return {
      //       fill:  'red' ,
      //     };
      //   },
      // },
    },
  };
  const peopleItems = [
    {
      label: "申报人数",
      value: 29,
      unit: "个",
    },

    {
      label: "人才补助",
      value: 39,
      unit: "万元",
    },
  ];

  const peoples = data?.talent.map((item: any) => {
    return {
      title: item.title,
      data: [
        {
          label: "申报人数",
          value: item.total,
          unit: "个",
        },
        {
          label: "人才补助",
          value: item.money,
          unit: "万元",
        },
      ],
    };
  });
  const st = [
    [
      {
        title: "龙子工程",
        data: peopleItems,
      },
      {
        title: "特支计划",
        data: peopleItems,
      },
    ],
    [
      {
        title: "骏马工程",
        data: peopleItems,
      },
      {
        title: "115创意团队",
        data: peopleItems,
      },
    ],
    [
      {
        title: "强马工程",
        data: peopleItems,
      },
      {
        title: "高精特新人才",
        data: peopleItems,
      },
    ],
  ];
  if (!data) {
    return null;
  }
  const xueliIcon =
    "data:image/png;base64,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";
  const ageIcon =
    "data:image/png;base64,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";

  return (
    <WisdonPartyBuildIngLayout>
      <div className={styles.commonBox}>
        <div className={styles.WisdomPartyBuilding}>
          <LiveTime />
          <MainLayout
            leftWidth={659}
            left={
              <div>
                <div className={classNames(styles.flex, styles.cardTitle)}>
                  <CardTitle
                    titleStyles={{
                      paddingLeft: 65,
                    }}
                    title="基本情况"
                  />
                  <YearPicker
                    defaultValue={currentYear}
                    onChange={(e, dateStr) => {
                      setCurrentYear(dateStr);
                    }}
                  />
                </div>
                <div
                  className={classNames(styles.flex, styles.valueBox)}
                  style={{ flexWrap: "wrap" }}
                >
                  {items.map((item, index) => (
                    <div
                      className={classNames(styles.valueItem, "box-container")}
                    >
                      <p className={styles.label}>{item}</p>
                      <div
                        className={classNames(
                          styles.flex,
                          styles.flexCenter,
                          styles.valueBox
                        )}
                      >
                        <strong className={styles.valueCount}>
                          {data.bases[`data${index + 1}`]}
                        </strong>
                        <span>个</span>
                      </div>
                    </div>
                  ))}
                  {/* {items.map((item, index) => (
                    <div key={index} className={styles.valueItem}>
                      <p className={styles.label}>{item}</p>
                      <div
                        className={classNames(
                          styles.flex,
                          styles.flexCenter,
                          styles.valueBox
                        )}
                      >
                        <strong className={styles.valueCount}>
                          {data.bases[`data${index + 1}`]}
                        </strong>
                        <span>个</span>
                      </div>
                    </div>
                  ))} */}
                </div>

                <div className={styles.proportionBox}>
                  <div
                    className={classNames(styles.flex)}
                    style={{ marginTop: 24 }}
                  >
                    <CardTitle
                      title="男女党员比例"
                      titleStyles={{
                        paddingLeft: 65,
                      }}
                    />
                  </div>
                  {data.bases && (
                    <EchartIconPie
                      dataOptions={[
                        {
                          name: "男",
                          value: data.bases.nan_bili,
                        },
                        {
                          name: "女",
                          value: data.bases.nv_bili,
                        },
                      ]}
                    />
                  )}
                  {/* <div
                    className={classNames(styles.flex, styles.proportion)}
                    style={{ marginTop: 25 }}
                  >
                    <span className={styles.itemText}>女性党员</span>
                    <span className={styles.value}>{data.bases.data8}</span>
                    <Progress percent={data.bases.nv_bili} status="active" />
                  </div>
                  <div className={classNames(styles.flex, styles.proportion)}>
                    <span className={styles.itemText}>男性党员</span>
                    <span className={styles.value}>{data.bases.data7}</span>
                    <Progress percent={data.bases.nan_bili} status="active" />
                  </div> */}
                </div>
                <div className={styles.flex} style={{ marginTop: 42 }}>
                  <div className={styles.flex1}>
                    <div className={styles.flex}>
                      <CardTitle
                        titleStyles={{
                          paddingLeft: 65,
                          height: 43,
                        }}
                        width={219}
                        title="党员年龄情况"
                      />
                    </div>
                    {data?.olds && (
                      <EchartAgePie
                        pieIcon={ageIcon}
                        imageIndex={0}
                        dataOptions={data?.olds?.map((item: any) => {
                          return {
                            name: item.name,
                            value: item.value,
                          };
                        })}
                      />
                    )}
                    {/* <div className={styles.pieContainer}>
                      <Pie {...config} />
                    </div> */}
                  </div>
                  <div className={styles.flex1}>
                    <div className={styles.flex}>
                      <CardTitle
                        titleStyles={{
                          paddingLeft: 65,
                          height: 43,
                        }}
                        width={219}
                        title="党员学历情况"
                      />
                    </div>
                    {data?.school && (
                      <EchartAgePie
                        pieIcon={xueliIcon}
                        imageIndex={1}
                        colorIndex={8}
                        dataOptions={data?.school?.map((item: any) => {
                          return {
                            name: item.name,
                            value: item.value,
                          };
                        })}
                      />
                    )}
                    {/* <div className={styles.pieContainer}>
                      <Pie
                        {...config}
                        data={data.school.map((item: any) => {
                          return {
                            type: item.name,
                            value: item.value,
                          };
                        })}
                      />
                    </div> */}
                  </div>
                </div>
                <div className={styles.proportionBox}>
                  {/* <div className={classNames(styles.flex)}>
                    <CardTitle
                      title="党费情况"
                      titleStyles={{
                        paddingLeft: 65,
                      }}
                    />
                  </div>
                  {data.money && (
                    <Echart3DOnlyBar
                      dataOptions={[
                        {
                          name: `机关支部(已收缴¥${
                            data.money[0].money || "-"
                          })`,
                          value: data.money[0].bili,
                        },
                        {
                          name: `企业党组织(已收缴¥${
                            data.money[1].money || "-"
                          })`,
                          value: data.money[1].bili,
                        },
                      ]}
                    />
                  )} */}
                  {/* <div
                    className={classNames(styles.flex, styles.proportion)}
                    style={{ marginTop: 25 }}
                  >
                    <span className={styles.itemText}>机关支部</span>
                    <span className={styles.value}>
                      已收缴¥{data.money[0].money}
                    </span>
                    <Progress percent={data.money[0].bili} status="active" />
                  </div>
                  <div className={classNames(styles.flex, styles.proportion)}>
                    <span className={styles.itemText}>企业党组织</span>
                    <span className={styles.value}>
                      已收缴¥{data.money[1].money}
                    </span>
                    <Progress percent={data.money[1].bili} status="active" />
                  </div> */}
                </div>
              </div>
            }
            rightWidth={519}
            middleStyle={{
              paddingLeft: 15,
              height: "auto",
            }}
            right={
              <div className={styles.rightContainer}>
                <div
                  className={styles.active}
                  style={{
                    marginTop: 40,
                  }}
                >
                  <CardTitle
                    titleStyles={{
                      paddingLeft: 65,
                    }}
                    title="党群活动"
                  />

                  <div
                    className={styles.flex}
                    style={{ marginTop: 11, paddingLeft: 10 }}
                  >
                    <div className={styles.bigPic}>
                      <img
                        src={currentActive.cover}
                        alt=""
                        style={{ borderRadius: "8px" }}
                      />
                      {/* <p>{currentActive.content}</p> */}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: currentActive.title,
                        }}
                      />
                    </div>
                    {/* <div className={styles.line1}></div> */}
                    <div className={styles.sliders}>
                      <Swiper
                        slidesPerView={3}
                        spaceBetween={24}
                        autoplay={{
                          delay: 2000,
                          // disableOnInteraction: false,
                        }}
                        loop={true}
                        pagination={{
                          clickable: true,
                        }}
                        onActiveIndexChange={(swiper: any) => {
                          console.log(swiper.realIndex);
                        }}
                        // navigation={true}
                        direction={"vertical"}
                        modules={[Autoplay, Pagination, Navigation]}
                        // modules={[Pagination, Navigation]}
                        className="mySwiper"
                      >
                        {data.active.map((slider: any, index: number) => (
                          <SwiperSlide>
                            {" "}
                            <div
                              className={styles.slider}
                              key={index}
                              onClick={() => {
                                setCurrentActive(slider);
                              }}
                              style={{
                                width: "100%",
                                marginBottom: "24px",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={slider.cover}
                                alt=""
                                style={{ borderRadius: "8px" }}
                              />
                              <div className={styles.desc}>
                                {slider.title.length >= 8
                                  ? slider.title.substr(0, 10) + "..."
                                  : slider.title}
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                </div>

                <div className={styles.infos}>
                  <CardTitle title="党员学习" />

                  <div style={{ height: 428 }} className="info-list">
                    <Swiper
                      slidesPerView={10}
                      spaceBetween={10}
                      autoplay={{
                        delay: 2000,
                        // disableOnInteraction: false,
                      }}
                      loop={false}
                      pagination={{
                        clickable: true,
                      }}
                      onActiveIndexChange={(swiper) => {
                        console.log(swiper.realIndex);
                      }}
                      // navigation={true}
                      direction={"vertical"}
                      modules={[Autoplay]}
                      // modules={[Pagination, Navigation]}
                      //   className="mySwiper"
                    >
                      {/* {[...data.article, ...data.article, ...data.article].map( */}
                      {data.article.map((info: any, index: number) => {
                        return (
                          <SwiperSlide>
                            {" "}
                            <div className="info-list-item" key={index}>
                              {info.title}
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                    {/* <ul>
                      {data.article.map((info: any, index: number) => {
                        return <li key={index}>{info.title}</li>;
                      })}
                    </ul> */}
                  </div>
                </div>
              </div>
            }
          >
            <div className="middle-content">
              {/* <div className="iframe-box">
                {!isYushan ? (
                  <img
                    src={mapimg}
                    style={{ height: 704, width: "100%", marginTop: 20 }}
                  />
                ) : (
                  <iframe
                    width="100%"
                    src="https://we.wxmas.cn/index/ysparty"
                  ></iframe>
                )}
              </div> */}
              <div>
                <div className={styles.flex1}>
                  <div className={styles.flex}>
                    <CardTitle
                      titleStyles={{
                        paddingLeft: 70,
                      }}
                      title="三会一课完成情况"
                    />
                  </div>
                  <ul className="quarters">
                    {quarters.map((item, index) => {
                      return (
                        <li key={index} className={styles.flex}>
                          <div>{item.label}</div>
                          {/* <img src={item.img} height={8} alt="" /> */}
                          <Progress
                            percent={data.san["data" + (index + 1)]}
                            status="active"
                          />
                          {/* <div>{data.san["data" + (index + 1)]}</div> */}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div style={{ flex: 1 }}>
                  <CardTitle
                    title="行业结构"
                    titleStyles={{
                      paddingLeft: 70,
                    }}
                  />
                  {data.industry && (
                    <Echart3DPie
                      dataOptions={data.industry?.map((item: any) => {
                        return {
                          name: item.name,
                          value: item.value,
                        };
                      })}
                    />
                  )}
                  {/*<div style={{ width: "80%" }}>
                   
                    <Pie
                      {...config}
                      data={data.industry.map((item: any) => {
                        return {
                          type: item.name,
                          value: item.value,
                        };
                      })}
                    /> 
                  </div>*/}
                </div>
              </div>
            </div>
          </MainLayout>
        </div>
      </div>
    </WisdonPartyBuildIngLayout>
  );
};

export default WisdomPartyBuilding;
